// extracted by mini-css-extract-plugin
export default {"table":"Table_table__V9pWW","row":"Table_row__IJghj","even":"Table_even__ITm0U","status":"Table_status__AQJnv"};